document.addEventListener("DOMContentLoaded", () => {

  const selectedItems = [];

  const discount =
    Number(
      document.querySelector(".bundle-top span:last-child")
      ?.textContent.match(/\d+/)?.[0]
    ) || 5;

  document.querySelectorAll(".bundle-add-btn")
  .forEach(btn => {

    btn.addEventListener("click", () => {

      const parent = btn.closest(".look-item");

      const variantId = btn.dataset.variant;
      const price = Number(parent.dataset.price);

      if(btn.classList.contains("active")){

        btn.classList.remove("active");
        btn.innerText = "+ Add";

        const index =
          selectedItems.findIndex(i => i.id === variantId);

        if(index > -1){
          selectedItems.splice(index,1);
        }

      } else {

        btn.classList.add("active");
        btn.innerText = "Added";

        selectedItems.push({
          id: variantId,
          quantity:1,
          price:price
        });
      }

      updateBundle();
    });

  });

  function updateBundle(){

    let subtotal = 0;

    selectedItems.forEach(item=>{
      subtotal += item.price;
    });

    const discountAmount =
      subtotal * (discount/100);

    const total =
      subtotal - discountAmount;

    document.getElementById("bundle-subtotal")
      .innerHTML = Shopify.formatMoney(subtotal);

    document.getElementById("bundle-discount")
      .innerHTML = "- " + Shopify.formatMoney(discountAmount);

    document.getElementById("bundle-total")
      .innerHTML = Shopify.formatMoney(total);
  }

  document
  .getElementById("bundle-cart-btn")
  ?.addEventListener("click", async ()=>{

    if(!selectedItems.length) return;

    await fetch('/cart/add.js',{
      method:'POST',
      headers:{
        'Content-Type':'application/json'
      },
      body:JSON.stringify({
        items:selectedItems.map(i=>({
          id:i.id,
          quantity:1
        }))
      })
    });

    window.location='/cart';
  });

});